import Page from 'flarum/common/components/Page';
import IndexPage from 'flarum/forum/components/IndexPage';
import Link from 'flarum/common/components/Link';
import app from 'flarum/forum/app';

export default class CoursesPage extends Page {
  oninit(vnode) {
    super.oninit(vnode);

    app.setTitle('Your Courses');
    app.setTitleCount(0);

    // Seed from whatever's already in the store (handles in-app navigation
    // where tags were loaded on a prior page).
    this.courses = this.getCourses();
    this.isLoadingTags = this.courses.length === 0;

    // Always fetch the tags index. app.store.all() does not hit the
    // network — on hard refresh the store is empty, so without an
    // explicit find() the dashboard renders as "No Courses Available"
    // and then nothing else ever triggers a tag fetch.
    app.store.find('tags')
      .then(() => {
        this.courses = this.getCourses();
        this.isLoadingTags = false;
        m.redraw();
      })
      .catch(() => {
        this.isLoadingTags = false;
        m.redraw();
      });
  }

  getCourses() {
    const courseTags = app.store
      .all('tags')
      .filter((tag) => typeof tag.slug === 'function' && tag.slug().startsWith('course-'));

    // Sort by oldest first (lowest ID = first created)
    return courseTags.sort((a, b) => a.id() - b.id());
  }

  view() {
    return (
      <div className="CoursesPage CoursesPage--wwa">
        {IndexPage.prototype.hero()}

        <div className="container">
          <div className="DeepIntegrationsCourseDashboard">
            {this.renderDashboard()}
          </div>
        </div>
      </div>
    );
  }

  renderDashboard() {
    if (this.isLoadingTags && !this.courses.length) {
      return (
        <div className="DeepIntegrationsCourseDashboard-empty">
          <h2>Loading your courses…</h2>
        </div>
      );
    }

    if (!this.courses.length) {
      return (
        <div className="DeepIntegrationsCourseDashboard-empty">
          <h2>Confirm your email to access course content…</h2>
        </div>
      );
    }

    return (
      <div>
        <div className="DeepIntegrationsCourseDashboard-header">
          <h1 className="DeepIntegrationsCourseDashboard-title">Choose your course below…</h1>
        </div>

        <div className="DeepIntegrationsCourseDashboard-grid">
          {this.courses.map(course => this.renderCourseCard(course))}
        </div>
      </div>
    );
  }

  renderCourseCard(tag) {
    const courseUrl = `/blog/category/${tag.slug()}`;

    // Get custom image from tag icon (if it's a URL) or use default
    const tagIcon = tag.icon();
    const hasCustomImage = tagIcon && (tagIcon.startsWith('http') || tagIcon.startsWith('/'));
    const backgroundStyle = hasCustomImage
      ? { backgroundImage: `url(${tagIcon})` }
      : {};

    const cardClass = hasCustomImage
      ? "DeepIntegrationsCourseCard"
      : "DeepIntegrationsCourseCard FlarumBlog-default-image";

    return (
      <Link
        href={courseUrl}
        className={cardClass}
        style={backgroundStyle}
        key={tag.id()}
      >
        <div className="DeepIntegrationsCourseCard-overlay"></div>
        <div className="DeepIntegrationsCourseCard-details">
          <h4>{tag.name()}</h4>
        </div>
      </Link>
    );
  }
}
